import type { ILink, IPagePath, IPartStoryTile } from "@contentful-api/types/contentful";

export function getStoryTileLink(editorialWidget: IPartStoryTile): IPagePath | ILink | undefined {
    return editorialWidget.fields?.link ?? editorialWidget.fields?.links?.[0];
}

export function isContentCardWidget(editorialWidget: IPartStoryTile): boolean {
    return editorialWidget.fields?.plpDisplayOption === true;
}
